module.exports = __webpack_public_path__ + "img/II-41.9277c916.svg";